export const hasRepositoryAccess = ({ allowRepository, allowAdminConsole }) => {
  return allowRepository && allowAdminConsole;
};

export const hasTopLevelRepositoryNav = ({
  allowRepository,
  allowTopLevelRepositoryNav,
  allowAdminConsole
}) => {
  return allowRepository && allowTopLevelRepositoryNav && allowAdminConsole;
};

export const hasPolicyPartnerAdminAccess = ({
  allowPolicyPartnerAdministration
}) => {
  return allowPolicyPartnerAdministration;
};

export const hasPolicyPartnerLearnerAccess = ({ allowPolicyPartner }) => {
  return allowPolicyPartner;
};

export const canManageContent = ({ silver, validate }) => {
  return !silver && !validate;
};

export const canAddCourse = ({ isInstructor, silver, validate }) => {
  return !isInstructor && canManageContent({ silver, validate });
};

export const canAddPolicy = ({ isInstructor, silver, validate }) => {
  return !isInstructor && canManageContent({ silver, validate });
};

export const canManageInstructors = ({
  silver,
  validate,
  allowManageInstructors
}) => {
  return canManageContent({ silver, validate }) && allowManageInstructors;
};

export const canEditEmployeeAssignments = ({
  isAdmin,
  customRoleEnabled,
  customRoleAddAssignments
}) => {
  return isAdmin || (customRoleEnabled && customRoleAddAssignments);
};

export const canViewEmployeeAssignments = ({
  isEmployeeManager,
  ...permissions
}) => {
  return canEditEmployeeAssignments(permissions) || isEmployeeManager;
};

export const notSaveEmployeeAssignments = ({
  isAdmin,
  isEmployeeManager,
  customRoleEnabled,
  customRoleAddAssignments
}) => {
  return (
    !isAdmin &&
    !(customRoleEnabled && customRoleAddAssignments) &&
    isEmployeeManager &&
    customRoleAddAssignments
  );
};

export const showFeatureSettings = ({
  allowValidate,
  allowGlobalAssignmentSettings
}) => {
  return allowValidate || allowGlobalAssignmentSettings;
};
